import { useQueryClient, useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useDeliveriesService } from 'services'
import { RootState } from 'store'
import {
  removeWheatCodeWithTaskIds,
  REQUESTSTATUS,
  updateWheatCodeWithTaskIdStatus,
} from 'store/slices/recalculateBinSlice'

export const useWheatCodePolling = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const { checkDeliveriesRecalculationStatus } = useDeliveriesService()
  const wheatCodeWithTaskIds = useSelector(
    (state: RootState) => state.recalculateBin.wheatCodeWithTaskIds
  )

  useQuery(
    ['poll_wheat_tasks'],
    async () => {
      if (!wheatCodeWithTaskIds || wheatCodeWithTaskIds.length === 0) {
        return []
      }

      const results = await Promise.all(
        wheatCodeWithTaskIds.map(async ({ wheatCodeId, taskId }) => {
          try {
            const result = await checkDeliveriesRecalculationStatus(taskId)
            if (result?.status === 'processing') {
              dispatch(
                updateWheatCodeWithTaskIdStatus({
                  taskId: taskId,
                  status: REQUESTSTATUS.IN_PROGRESS,
                })
              )
            }
            return { wheatCodeId, taskId, result }
          } catch (e) {
            console.error(`Error polling ${taskId}`)
            return null
          }
        })
      )

      return results.filter(Boolean)
    },
    {
      enabled: !!wheatCodeWithTaskIds?.length,
      refetchInterval: 3000,
      onSuccess: (results: any[]) => {
        results.forEach(({ wheatCodeId, taskId, result }) => {
          if (result?.status === 'completed') {
            dispatch(removeWheatCodeWithTaskIds(wheatCodeId))
            queryClient.invalidateQueries(['wheat_codes_list'])
          }
        })
      },
    }
  )
}
